/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { FileHelper } from '../Helpers/FileHelper';

const getHeaders = () => {
    const headers = new Headers();
    headers.append('Accept-Language', document.documentElement.lang);
    return headers;
};

const formatAddress = (
    street: string,
    number: string,
    postal: string,
    locality: string
) => `${street} ${number}, ${postal} ${locality}`;

export const PrimeIndependantService = {
    async pushData(request: any, captchaToken: string) {
        const formData = new FormData();

        const cleanedRequest = {
            ...request,
            nationalRegisterApplicant:
                request.nationalRegisterApplicant.replace(/\.|-/g, ''),
            numberCompany: request.numberCompany.replace(/\./g, ''),
            addressCompany: formatAddress(
                request.addressStreet,
                request.addressNumber,
                request.addressPostal,
                request.addressLocality
            ),
            addressApplicant: formatAddress(
                request.addressStreetApplicant,
                request.addressNumberApplicant,
                request.addressPostalApplicant,
                request.addressLocalityApplicant
            ),
        };

        if (cleanedRequest.aceAttestationFile) {
            formData.append(
                'files',
                FileHelper.handleFileUpload(cleanedRequest.aceAttestationFile)
            );
        }

        if (cleanedRequest.affiliationProofFile) {
            formData.append(
                'files',
                FileHelper.handleFileUpload(cleanedRequest.affiliationProofFile)
            );
        }

        if (cleanedRequest.bankAttestationFile) {
            formData.append(
                'files',
                FileHelper.handleFileUpload(cleanedRequest.bankAttestationFile)
            );
        }

        Object.entries(cleanedRequest).forEach(([key, value]) => {
            if (
                key !== 'aceAttestationFile' &&
                key !== 'affiliationProofFile' &&
                key !== 'bankAttestationFile'
            ) {
                formData.append(key, value as string);
            }
        });

        formData.append('captchaToken', captchaToken);

        return await fetch('/api/FondsRebond/PushIndependant', {
            method: 'POST',
            body: formData,
            headers: getHeaders(),
        });
    },
};
